import React from "react";
import classes from './Projects.module.scss'
import {Project} from "./Project";
import rozvrh from '../../images/rozvrh.png'
import smarthome from '../../images/smarthome.jpg'
import Rozvrh from "./Rozvrh";
import NeoHome from "./NeoHome";
import ReactGA from 'react-ga'

const Projects = () => {

	return (
		<div className={classes.root}>
			<h2>Moje projekty</h2>

			<div className={classes.projects}>
				<Project
					onOpen={() => ReactGA.event({category: 'User', action: 'Open project info', label: 'NeoHome'})}
					image={smarthome}
					heading='NeoHome'
						 text='Komplexní systém pro chytrou domácnost, který se stará o zjednodušení našeho života'>
					<NeoHome/>
				</Project>
				<Project
					onOpen={() => ReactGA.event({category: 'User', action: 'Open project info', label: 'Rozvrh'})}
					image={rozvrh}
					heading='Rozvrh'
					text='Jeden z mých prvních projektů, který byl dlouhou dobu k dispozici na telefony se systemém Android'>
					<Rozvrh/>
				</Project>
			</div>
		</div>
	)
}

export default Projects